import { Button, Fade, Modal, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FormattedMessage } from 'react-intl';

import BackupCodeField from './backupCodeDownloadField';

import { gradientBackground } from '../../../assets/styles/button.style';
import modalExitIcon from '../../../assets/svg/modalExitIcon.svg';
import { StepTwoModalProps } from '../../../interfaces/ModalProps';

const TwoFactorAuthenticationActivatedModal = ({
  open,
  handleClose,
  backupCode,
}: StepTwoModalProps) => {
  const handleClick = () => {
    handleClose();
    window.location.reload();
  };
  return (
    <>
      <Modal open={open} onClose={() => {}} closeAfterTransition>
        <Fade in={open}>
          <Box
            sx={{
              position: 'absolute' as const,
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '605px',
              height: '358px',
              bgcolor: 'rgba(255, 255, 255, 1)',
              borderRadius: '6px',
              boxShadow: 24,
              p: '32px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Button
              onClick={handleClick}
              sx={{
                width: '28px',
                height: '28px',
                position: 'absolute',
                right: '1px',
              }}
            >
              <img src={modalExitIcon} alt='exit-icon'></img>
            </Button>
            <Typography
              sx={{
                fontFamily: 'Schibsted Grotesk',
                fontWeight: 500,
                fontSize: '18px',
              }}
            >
              <FormattedMessage defaultMessage='Two-Factor Authentication is now activated' />
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Schibsted Grotesk',
                fontWeight: 400,
                fontSize: '14px',
                color: 'rgba(135, 135, 135, 1)',
                lineHeight: '22px',
                mt: '4px',
                textAlign: 'justify',
                pr: 9,
              }}
            >
              <FormattedMessage
                defaultMessage='To mitigate the risk of losing access to your account, please download 
              and securely store the backup code. It is advisable to save it in a 
              secondary location for safekeeping. Be aware that losing this code could 
              lead to delays in account recovery.'
              />
            </Typography>
            
            <BackupCodeField backupCode={backupCode} />

            
            <Button
              onClick={handleClick}
              sx={{
                ...gradientBackground,
                mt: '40px',
                mb: '32px',
              }}
            >
              <FormattedMessage defaultMessage='Done' />
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default TwoFactorAuthenticationActivatedModal;
